import type { ReactNode } from 'react';
import { CopyIcon, Icon, useToastController, XStack } from 'smoothie';

export const CopyableTextField = ({
    value,
    children,
}: {
    value?: string | null;
    children: ReactNode;
}) => {
    const toast = useToastController();
    return (
        <XStack
            gap={4}
            flex={1}
            alignItems="center"
            style={{ cursor: 'pointer' }}
            onPress={() => {
                if (value != null && value.length > 0) {
                    void navigator.clipboard.writeText(value);
                    toast.show(`${value} copied!`, { duration: 2000 });
                }
            }}
        >
            {children}
            {value != null && value.length > 0 && (
                <Icon icon={CopyIcon} size={18} color="$black" />
            )}
        </XStack>
    );
};
